import { Chip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

export function RatingChip({ rating = 0, count = 0 }) {
  const hasReviews = count > 0;
  const icon = hasReviews
    ? <StarIcon sx={{ color: '#fbc02d !important' }} />
    : <StarBorderIcon />;

  const formatted = (rating || 0).toFixed(1);

  return (
    <Chip
      variant="outlined"
      icon={icon}
      label={hasReviews ? `${formatted} (${count})` : `${formatted}`}
      sx={{ border: '0px', justifyContent: 'left' }}
    />
  );
}
